import React, {useState} from 'react'
import { Select, Typography, Row, Col, Avatar, Card, } from 'antd'
import { QuestionOutlined } from '@ant-design/icons'
import moment from 'moment'
import Loader from './Loader'

import { useGetCryptoNewsQuery } from '../services/cryptoNewsApi'
import { useGetCryptosQuery } from '../services/cryptoApi'

const { Text, Title } = Typography
const { Option } = Select

// const demoImage = 'http://coinrevolution.com/wp-content/uploads/2020/06/cryptonews.jpg'

const News = ({simplified}) => {
  const [count, setCount] = useState(6)
  // if (!simplified) {
  //   setCount(12)
  // } 
  const [newsCategory, setNewsCategory] = useState('Cryptocurrency')
  const { data: cryptoNews } = useGetCryptoNewsQuery(newsCategory, count)
  const { data } = useGetCryptosQuery(100)
  
  if(!cryptoNews?.value) return <Loader />
  
  return (
    <Row gutter={[24, 24]}>
      {!simplified && (
        <Col span={24}>
          <Select
            showSearch
            className="select-news"
            placeholder="Select a Crypto"
            optionFilterProp='children'
            onChange={(value) => setNewsCategory(value)}
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
              <Option value="Cryptocurrency">
                Cryptocurrency
              </Option>
              {data?.data?.coins.map((coin) => <Option value={coin.name}>{coin.name}</Option>)}
          </Select>

        </Col>
      )}
      {cryptoNews.value.map((news, i) => (
        <Col xs={24} sm={12} lg={8} key={i}>
          <Card hoverable className="news-card">
            <a href={news.url} target="_blank" rel="noreferrer">
              <div className="news-image-container">
                    <Title className="news-title" level={4}>
                      {news.name}
                    </Title>
                    {news?.image?.thumbnail?.contentUrl ? <img src={news?.image?.thumbnail?.contentUrl} alt="news" /> : <QuestionOutlined />}
              </div>
              <p>
                {news.description > 100 ? `${news.description.substring(0,100)}...` : news.description}
              </p>
              <div classname="provider-container">
                <div>
                  {news.provider[0]?.image?.thumbnail?.contentUrl ? <Avatar src={news.provider[0]?.image?.thumbnail?.contentUrl} alt="news" /> : <QuestionOutlined /> }
                  <Text className="provider-name"> {news.provider[0]?.name}</Text>

                </div>
                  <Text>{moment(news.datePublished).startOf('ss').fromNow()} </Text>

              </div>
            </a>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default News